import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

// กันหน้าที่ต้อง login — role = "admin" สำหรับฝั่ง /admin
export default function RequireAuth({ role, children }) {
  const { isLoggedIn, isAdmin } = useApp();
  const location = useLocation();

  if (!isLoggedIn) return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  if (role === "admin" && !isAdmin) return <Navigate to="/app" replace />;

  return children;
}
